import React, { useEffect } from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

import { EnvelopeJustification } from '@paragon/contract-library';
import { forceArray, isInput } from '@paragon/utilities';

const options: EnvelopeJustification[] = ['Front', 'Center', 'Back'];

interface Props {
  readonly disabled?: boolean;
  readonly value: EnvelopeJustification | EnvelopeJustification[];
  readonly onChange?: (value: EnvelopeJustification) => void;
}

export function EnvelopeJustificationToggle({ disabled, value, onChange }: Props) {
  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (isInput(event.target as HTMLElement)) return;

      if (event.altKey && event.key === 'j') {
        event.preventDefault();

        if (onChange) {
          onChange(options.concat([options[0]])[options.indexOf(forceArray(value)[0]) + 1]);
        }
      }
    }

    document.addEventListener('keydown', onKeyDown);
    return () => void document.removeEventListener('keydown', onKeyDown);
  }, [onChange, value]);

  return (
    <Box>
      <Typography
        gutterBottom
        variant="subtitle2"
        sx={{
          color: disabled ? (theme) => theme.palette.text.disabled : undefined,
        }}
      >
        Justification
      </Typography>

      <ToggleButtonGroup
        exclusive
        fullWidth
        disabled={disabled}
        size="small"
        value={value}
        onChange={(_, newValue) => {
          if (newValue && onChange) onChange(newValue);
        }}
      >
        {options.map((option) => (
          <ToggleButton key={option} value={option}>
            {option}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}
